<template>
  <div class="search-panel">
    <div
      v-for="availableTopFilter in availableTopFilters"
      :key="availableTopFilter.attribute"
      class="search-panel__filters trxlcs"
      :class="{
        'filter-opened': dropdownToggle[availableTopFilter.attribute],
        'd-none': !filters.includes(availableTopFilter.key),
        ssws_search_sec: !availableTopFilter.copySelect,
      }"
    >
      <div v-if="availableTopFilter.copySelect" class="ssws_search_panel-tab">
        <label :key="availableTopFilter.key" :for="availableTopFilter.key">{{
          copy[availableTopFilter.copyKey]
        }}</label>
      </div>
      <div v-if="availableTopFilter.copySelect" class="ssws_search_input 11">
        <ais-refinement-list
          :attribute="availableTopFilter.attribute"
          :limit="limitRefinementList"
          :searchable="true"
          searchable-placeholder="tesgsdhf "
        >
          <div slot-scope="{ items, refine }">
            <multiselect
              :id="availableTopFilter.key"
              label="label"
              aria-expanded="false"
              track-by="value"
              :v-model="fnselect(availableTopFilter.attribute)"
              @select="
                (selectedOption, id) => {
                  refine(selectedOption.value);
                }
              "
              @remove="
                (removedOption, id) => {
                  refine(removedOption.value);
                }
              "
              :block-keys="['Tab']"
              :options="items"
              :multiple="true"
              :placeholder="copy[availableTopFilter.copySelect]"
              selectLabel=""
              deselectLabel=""
              selectedLabel=""
              class="listboxsearchpanel"
            >
              <template
                slot="option"
                slot-scope="props"
                :data-insights-filter="`${availableTopFilter.key}:${item.value}`"
              >
                <span class="option_label">{{ props.option.label }}</span>
                <b class="label_count">{{ props.option.count }}</b>
              </template>

              <template slot="selection" slot-scope="{ values, search, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length"
                  v-show="!isOpen"
                  >{{ copy[availableTopFilter.copySelect] }}</span
                ></template
              >

              <span slot="noResult"> {{ copy.noResults }} </span>
            </multiselect>
          </div>
        </ais-refinement-list>
      </div>
      <div v-if="!availableTopFilter.copySelect" class="ssws_search_panel-tab">
        <h3>{{ copy[availableTopFilter.copyKey] }}</h3>
      </div>
      <div v-if="!availableTopFilter.copySelect" class="ssws_search_input 22">
        <ais-search-box
          :placeholder="copy[availableTopFilter.copyPlaceholder]"
          class="searchbox"
          :submit-title="copy[availableTopFilter.copyPlaceholder]"
        />
      </div>
    </div>

    <!-- MORE FILTERS -->
    <div
      class="search-panel__filters more-filters"
      :class="{ 'filter-opened': dropdownToggle['more'] }"
      v-if="atLeastOneInPanel"
    >
      <!-- TOGGLE -->
      <div class="ssws_search_panel-tab">
        <span
          class="ssws_search_panel-tab-button more-btn"
          @click="toggleFilterPanel('more')"
          role="button"
          tabindex="0"
          aria-labelledby="tac"
          aria-expanded="false"
          v-on:keyup.enter="toggleFilterPanel('more')"
          @keyup.esc="closeAllPanels()"
        >
          <span class="down-arrow">
            <svg
              enable-background="new 0 0 612 612"
              version="1.1"
              viewBox="0 0 612 612"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m306 0c-169.01 0-306 136.99-306 306s136.99 306 306 306 306-137.01 306-306-136.99-306-306-306zm163.23 246.31-146.44 146.44c-4.59 4.59-10.863 6.005-16.811 4.973-5.929 1.052-12.221-0.383-16.811-4.973l-146.44-146.44c-7.478-7.478-7.478-19.565 0-27.043s19.584-7.478 27.042 0l136.23 136.19 136.19-136.19c7.478-7.478 19.584-7.478 27.042 0 7.479 7.459 7.479 19.565 0 27.043z"
              />
            </svg>
          </span>
          <span id="tac">{{ copy.showMoreChoices }}</span>
        </span>
      </div>
      <!-- PANEL -->
      <div class="ssws_search_panel_dropdown">
        <div class="ssws_search_panel_inner_sec">
          <div class="morechoice-section">
            {{ copy.showMoreChoices }}
            <button
              class="ais-CurrentRefinements-delete"
              @click="toggleFilterPanel('more')"
            >
              ✕
            </button>
          </div>
          <div class="search-more-item-wrap">
            <div
              v-for="availableFilter in availablePanelFilters"
              :key="availableFilter.key"
              class="search-panel__filters"
              :class="{
                'd-none': !filters.includes(availableFilter.key),
                is_new_6: availableFilter.key === 'sswsIsNew',
              }"
            >
              <h3 role="heading" aria-level="3" tabindex="0">
                {{ copy[availableFilter.copyKey] }}
              </h3>
              <ais-refinement-list
                v-if="typeof availableFilter.transform !== 'undefined'"
                :limit="limitRefinementList"
                :attribute="availableFilter.attribute"
                :transform-items="availableFilter.transform"
              >
                <template v-slot:item="{ item, refine, createURL }">
                  <a
                    :href="createURL(item.value)"
                    :style="{ fontWeight: item.isRefined ? 'bold' : '' }"
                    @click.prevent="refine(item.value)"
                    class="cstm_refinestyle"
                    :data-insights-filter="`${availableFilter.key}:${item.value}`"
                  >
                    <span
                      class="styleRefinementList-label"
                      v-if="item.label === 'true'"
                      >Ja</span
                    >
                    <span
                      class="styleRefinementList-label"
                      v-else-if="item.label === 'false'"
                      >Nej</span
                    >
                    <span class="styleRefinementList-label" v-else>{{
                      item.label
                    }}</span>
                    <span class="ais-RefinementList-count">
                      {{ item.count.toLocaleString() }}
                    </span>
                  </a>
                </template>
              </ais-refinement-list>

              <ais-refinement-list
                v-if="typeof availableFilter.transform === 'undefined'"
                :limit="limitRefinementList"
                :attribute="availableFilter.attribute"
              >
                <template v-slot:item="{ item, refine, createURL }">
                  <a
                    :href="createURL(item.value)"
                    :style="{ fontWeight: item.isRefined ? 'bold' : '' }"
                    @click.prevent="refine(item.value)"
                    class="cstm_refinestyle"
                    :data-insights-filter="`${availableFilter.key}:${item.value}`"
                  >
                    <span
                      class="styleRefinementList-label"
                      v-if="item.label === 'true'"
                      >Ja</span
                    >
                    <span
                      class="styleRefinementList-label"
                      v-else-if="item.label === 'false'"
                      >Nej</span
                    >
                    <span class="styleRefinementList-label" v-else>{{
                      item.label
                    }}</span>
                    <span class="ais-RefinementList-count">
                      {{ item.count.toLocaleString() }}
                    </span>
                  </a>
                </template>
              </ais-refinement-list>
            </div>
          </div>
          <div class="morechoice-section-btn">
            <span
              class="morechoice-button"
              @click="toggleFilterPanel('more')"
              role="button"
              tabindex="0"
              aria-labelledby="tac"
              aria-expanded="false"
              v-on:keyup.enter="toggleFilterPanel('more')"
              @keyup.esc="closeAllPanels()"
              >{{ copy.applyChanges }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable vue/no-unused-components, prettier/prettier, no-console */
import availableFilters from '../utility/filters';
import localize from '../utility/localize';
import jQuery from 'jquery';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      dropdownToggle: {},
      selectedValues: {},
      limitRefinementList: 100,
      availableFilters: availableFilters,
    };
  },
  props: {
    filters: Array,
    copy: Object,
    selectedValuesList: Object,
  },
  computed: {
    availableTopFilters: function () {
      return this.availableFilters.filter((x) => x.position === 'top');
    },
    availablePanelFilters: function () {
      return this.availableFilters.filter((x) => x.position === 'panel');
    },
    atLeastOneInPanel: function () {
      const isIncluded = this.availablePanelFilters.some(
        (v) => this.filters.indexOf(v.key) !== -1
      );
      return isIncluded;
    },
  },
  mounted() {
    let countt = 0;
    window.addEventListener('keyup', function (event) {
      if (event.target) {
        var currentElement = event.target;
        var elementId = currentElement.id;
        if (jQuery.inArray(elementId, ['tjanst', 'lan', 'kommun']) >= 0) {
          if (event.keyCode === 38) {
            if (countt >= 0) {
              countt--;
              jQuery(`#${elementId}`).attr('aria-activedescendant', countt);
            }
            jQuery('#option_0_itemiId_3').attr('aria-selected', true);
          }
          if (event.keyCode === 40) {
            countt++;
            jQuery(`#${elementId}`).attr('aria-activedescendant', countt);
            jQuery('#option_0_itemiId_2').attr('aria-selected', true);
          }
        }
      }
    });

    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      var that = this;

      jQuery('.multiselect__input').attr('aria-activedescendant', '');

      // === A11y: ensure proper ARIA combobox semantics on the actual input ===
      // 1) Input has role=combobox, aria-haspopup=listbox; expanded set on focus/blur
      jQuery('.multiselect__input')
        .attr('role', 'combobox')
        .attr('aria-haspopup', 'listbox');

      jQuery(document).on(
        'focus',
        '.ssws_search_panel-tab .multiselect__input',
        function () {
          jQuery(this).attr('aria-expanded', true);
        }
      );
      jQuery(document).on(
        'blur',
        '.ssws_search_panel-tab .multiselect__input',
        function () {
          jQuery(this).attr('aria-expanded', false);
        }
      );

      // 2) Accessible name & ids: wire up label -> input, and input -> listbox
      jQuery('.ssws_search_panel-tab').each(function (i) {
        const $tab = jQuery(this);
        const $label = $tab.find('label[for]').first();
        const base = $label.length ? $label.attr('for') : 'combobox' + i;

        if ($label.length) {
          $label.attr('id', base + '-label');
        }
        const $input = $tab.find('.multiselect__input').first();
        if ($input.length) {
          $input.attr('id', base);
          $input.attr('aria-labelledby', base + '-label');
          $input.attr('aria-autocomplete', 'list');
        }

        const $list = $tab.find('.multiselect__content').first();
        if ($list.length) {
          $list
            .attr('id', base + '-listbox')
            .attr('role', 'listbox')
            .attr('aria-multiselectable', 'true');
          if ($input.length) {
            $input.attr('aria-controls', base + '-listbox');
          }
          // 3) Options with role=option and stable ids
          $list.find('li.multiselect__element').each(function (j) {
            jQuery(this)
              .attr('role', 'option')
              .attr('id', base + '-option-' + j)
              .attr('aria-selected', 'false');
          });
        }
      });

      // 4) Keep aria-activedescendant and aria-selected in sync with highlight/mouse
      jQuery(document).on(
        'keyup',
        '.ssws_search_panel-tab .multiselect__input',
        function (e) {
          const $tab = jQuery(this).closest('.ssws_search_panel-tab');
          const $hi = $tab
            .find('.multiselect__option--highlight')
            .closest('li.multiselect__element');
          $tab.find('li.multiselect__element').attr('aria-selected', 'false');
          if ($hi.length) {
            $hi.attr('aria-selected', 'true');
            jQuery(this).attr('aria-activedescendant', $hi.attr('id'));
          } else {
            jQuery(this).attr('aria-activedescendant', '');
          }
          if (e.key === 'Escape') {
            jQuery(this).attr('aria-expanded', 'false');
            this.blur();
          }
        }
      );

      jQuery(document).on(
        'mousemove',
        '.multiselect__content li.multiselect__element',
        function () {
          const $li = jQuery(this);
          const $tab = $li.closest('.ssws_search_panel-tab');
          $tab.find('li.multiselect__element').attr('aria-selected', 'false');
          $li.attr('aria-selected', 'true');
          const $input = $tab.find('.multiselect__input');
          $input.attr('aria-activedescendant', $li.attr('id'));
        }
      );
      // === end A11y block ===

      setInterval(() => {
        const selectedtag = jQuery('.multiselect__tag span');
        selectedtag.attr('role', 'button');
        selectedtag.attr('tabindex', '0');
        jQuery('.ais-RefinementList-labelText').attr({
          tabindex: '0',
        });
      }, 300);
      setTimeout(() => {
        jQuery('.multiselect__input').each(function () {
          jQuery(this).removeAttr('autocomplete');
        });
        jQuery(document).on('click', '.more-btn', function () {
          if (jQuery(this).attr('aria-expanded') == 'false') {
            jQuery(this).attr('aria-expanded', 'true');
          } else {
            jQuery(this).attr('aria-expanded', 'false');
          }
        });
        jQuery(document).on(
          'focus',
          '.ais-RefinementList .multiselect__input',
          function () {
            jQuery(this).attr('aria-expanded', true);
            jQuery(this).find('input').attr('autocomplete', 'off');
          }
        );
        jQuery(document).on(
          'blur',
          '.ais-RefinementList .multiselect__input',
          function () {
            jQuery(this).attr('aria-expanded', false);
            jQuery(this).find('input').attr('autocomplete', 'off');
          }
        );
        jQuery('.ais-RefinementList .multiselect__input').attr(
          'autocomplete',
          'off'
        );
        jQuery('.listboxsearchpanel').attr('role', 'combobox');
        const inputButton = jQuery('.listboxsearch');
        inputButton.keyup(function (event) {
          console.log('event..', event);
          jQuery('.multiselect__element').attr('aria-selected', false);
          const tp = jQuery(this)
            .find('.multiselect__option--highlight')
            .parent();
          tp.attr('aria-selected', true);
          jQuery('.multiselect__input').attr('aria-activedescendant', '');
          const cruId = tp.attr('id');
          jQuery(this)
            .find('.multiselect__input')
            .attr('aria-activedescendant', cruId);
        });

        // Code that will run only after the
        // entire view has been rendered
        if (jQuery('.ais-RefinementList').find('.multiselect__input').length) {
          let multiselectInput = jQuery('.ais-RefinementList').find(
            '.multiselect__input'
          );
          let multiselectContent = jQuery('.ais-RefinementList').find(
            '.multiselect__content'
          );

          multiselectInput.attr('aria-autocomplete', 'list');
          multiselectContent.attr('role', 'listbox');
          multiselectInput.each((i, elm) => {
            jQuery(elm).attr('aria-controls', `optionselection_${i}`);
          });
          if (multiselectContent.length) {
            multiselectContent.each((ulindx, obj) => {
              jQuery(obj).attr('id', `optionselection_${ulindx}`);
              let collectAll = jQuery(obj).find('li');
              collectAll.each((j, elmt_li) => {
                let cr = jQuery(elmt_li);
                if (cr.hasClass('multiselect__element')) {
                  cr.attr('role', 'option');
                  cr.attr('id', `option_${ulindx}_itemiId_${j}`);
                  cr.attr('aria-selected', false);
                } else {
                  cr.attr('role', 'alert');
                }
              });
            });
          }
          jQuery('.multiselect__input').attr('aria-activedescendant', '');
        }
      }, 2000);

      document.addEventListener(
        'mouseup',
        function (e) {
          var container = document.getElementsByClassName('search-panel')[0];
          if (container && !container.contains(e.target)) {
            that.closeAllPanels();
          }
        }.bind(this)
      );
    });
    window.setInterval(() => {
      let searchExclude = localize('searchExclude')
        ? localize('searchExclude')
        : '';
      let lists = jQuery('.trxlcs .ais-RefinementList-list').find(
        '.ais-RefinementList-item'
      );
      let i = 0;
      let exculdeElement = searchExclude.split(',');
      for (i = 0; i <= lists.length; i++) {
        if (
          exculdeElement.includes(
            jQuery(lists[i]).find('.ais-Highlight').text()
          )
        ) {
          jQuery(lists[i]).hide();
        }
      }
    }, 300);
  },
  methods: {
    onArrowDown(evnt) {
      let targetId = evnt.currentTarget.id;
      console.log('targetId', targetId);
    },
    fnselect(slectedValues) {
      let uri = window.location.href.split('?');
      let getVars = {};
      if (uri.length == 2) {
        let vars = uri[1].split('&');
        let tmp = '';
        vars.forEach(function (v) {
          tmp = v.split('=');
          if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
        });
      }

      console.log(slectedValues);
      return ['Dagverksamhet', 'Äldreboende omvårdnad'];
    },
    toggleFilterPanel(panel) {
      let v = !this.dropdownToggle[panel];
      this.closeAllPanels();
      this.dropdownToggle[panel] = v;
    },
    closeAllPanels() {
      this.dropdownToggle = {};
    },
  },
};
</script>
<style>
.search-panel {
  position: relative;
  align-items: flex-end;
  margin-bottom: 2rem;
  display: flex;
}

.search-panel .search-panel__filters {
  flex: 1;
  margin-right: 1rem;
  position: relative;
}

.search-panel .search-panel__filters.filter-opened .ssws_search_panel_dropdown {
  opacity: 1;
  visibility: visible;
}

.search-panel .search-panel__filters.more-filters .ssws_search_panel_dropdown {
  margin-top: 20px;
}

.search-panel
  .search-panel__filters.more-filters
  .ssws_search_panel_dropdown
  .search-panel__filters {
  margin-right: 0px;
}

.search-panel .search-more-item-wrap .search-panel__filters {
  width: 33.333%;
  -webkit-box-flex: 0 0 33.333%;
  -ms-flex: 0 0 33.333%;
  flex: 0 0 33.333%;
  padding: 0 5px;
}

.search-panel span.arrow-down.openList {
  width: 10px;
}

.search-panel .search-panel__filters.filter-opened span.arrow-down.openList svg,
.search-panel .search-panel__filters.filter-opened span.down-arrow svg {
  transform: rotate(180deg);
}

.search-panel .ssws_search_panel-tab-button.more-btn img {
  height: 20px;
  width: 20px;
  margin-right: 15px;
}

.search-panel .ssws_search_panel-tab-button {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
  position: relative;
}

.search-panel .search-more-item-wrap {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;
}

.search-panel .ssws_search_panel_dropdown {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  width: 100%;
  top: 100%;
  left: 0;
  padding: 5px 10px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 0 20px 20px;
  z-index: 2;
}

.search-panel .search-panel__filters.more-filters {
  flex: 0 0 auto;
  position: static;
}

.search-panel .down-arrow {
  width: 20px;
}

.search-panel .more-btn span.down-arrow {
  border: none;
}

.search-panel .more-btn span.down-arrow svg {
  margin-right: 4px;
}

.search-panel
  .search-panel__filters:not(.more-filters)
  .ssws_search_panel_dropdown {
  max-height: 720px;
  overflow-y: scroll;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #444 !important;
}
.search-panel .ais-InstantSearch {
  position: relative;
  z-index: 999;
}
.search-panel .multiselect__tag i:after {
  color: #fff;
  font-size: 100%;
}

.search-panel .multiselect__tag i {
  line-height: 1;
  font-size: 20px;
  font-weight: normal;
  top: -1px;
}
.search-panel .multiselect__option--highlight {
  background-color: #de3f2a;
}

.search-panel .multiselect__option--selected {
  font-family: BrownStd, sans-serif;
  font-weight: 400;
  color: #000;
}

.search-panel .multiselect__option--selected.multiselect__option--highlight {
  background: #de3f2a !important;
  color: #fff !important;
}
.multiselect__option span.option_label {
  position: relative;
  z-index: 0;
}
.search-panel .multiselect__content {
  background-color: #fff;
  overflow: auto;
  z-index: 1;
  border: 1px solid #e9e9e9;
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.label_count {
  padding: 0.1rem 0.4rem;
  font-size: 0.8rem;
  border-radius: 8px;
  background-color: #de3f2a;
  color: #fff;
  margin: 0 0 0 3px;
}
.search-panel .multiselect__option--selected span.option_label:before {
  width: 13px;
  height: 14px;
  display: inline-block;
  color: #0075ff;
  margin: -1px 5px 0 -4px;
  content: '\f14a';
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  border: none;
  position: relative;
  z-index: 2;
}
.search-panel .multiselect__option--selected span.option_label:after {
  content: '';
  position: absolute;
  top: 1px;
  background: #fff;
  width: 11px;
  height: 11px;
  left: -2px;
  z-index: 1;
}
.multiselect__option--selected.multiselect__option--highlight:after {
  display: none !important;
}
.nytida-website .multiselect__option--highlight,
.nytida-website .label_count {
  background-color: #6ab651 !important;
}
.altiden-website .multiselect__option--highlight,
.altiden-website .label_count {
  background-color: #b8460f !important;
}
.altiden-website .multiselect__option--highlight,
.altiden-website .label_count {
  background-color: #b8460f !important;
}
.lara-2021 .multiselect__option--highlight,
.lara-2021 .label_count {
  background-color: #0075bf !important;
}
.stendi-website .multiselect__option--highlight,
.stendi-website .label_count {
  background-color: #b8460f !important;
}
.altiden-website .multiselect__option--highlight,
.altiden-website .label_count {
  background-color: #b8460f !important;
}
.svv-search-list
  .ais-InstantSearch
  .search-panel
  .ssws_search_panel_dropdown
  .ais-RefinementList-item
  a {
  cursor: pointer;
  width: 100%;
  margin: 0;
  padding: 0.35rem 0;
}
.svv-search-list
  .ais-InstantSearch
  .search-panel
  .ssws_search_panel_dropdown
  .ais-RefinementList-item
  a:hover {
  background-color: #de3f2a;
  color: #fff;
}

.nytida-website .ais-RefinementList-item a:hover {
  background-color: #6ab651 !important;
  color: #fff !important;
}
.altiden-website .ais-RefinementList-item a:hover {
  background-color: #b8460f !important;
  color: #fff !important;
}
.lara-2021 .ais-RefinementList-item a:hover {
  background-color: #0075bf !important;
  color: #fff !important;
}
.stendi-website .ais-RefinementList-item a:hover {
  background-color: #b8460f !important;
  color: #fff !important;
}

.svv-search-list
  .ais-InstantSearch
  .search-panel
  .ssws_search_panel_dropdown
  .ais-RefinementList-item
  a {
  cursor: pointer;
  width: 100%;
  margin: 0;
  padding: 0.35rem 0.5rem;
  display: block;
  text-decoration: none;
}
.cstm_refinestyle span.ais-RefinementList-count {
  margin-left: 5px;
}
.ais-RefinementList-item--selected a .styleRefinementList-label {
  position: relative;
  margin-left: 20px;
}
.ais-RefinementList-item--selected a .styleRefinementList-label:before {
  position: absolute;
  content: '';
  top: 2px;
  left: -20px;
  height: 15px;
  width: 15px;
  background-color: #2196f3;
}
.ais-RefinementList-item--selected a .styleRefinementList-label:after {
  left: -15px;
  top: 3px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  content: '';
  position: absolute;
}

@media (max-width: 991px) {
  .search-panel .search-more-item-wrap .search-panel__filters {
    width: 50%;
    -webkit-box-flex: 0 0 50%;
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    padding: 0 5px;
  }
}

@media (max-width: 767px) {
  .search-panel {
    align-items: flex-start;
    flex-direction: column;
  }
  .search-panel .search-panel__filters {
    margin-right: 0;
    width: 100%;
    flex: 0 0 100%;
  }
  .search-panel
    .search-panel__filters.more-filters
    .ssws_search_panel_dropdown {
    max-height: 340px;
    overflow-y: scroll;
  }

  .ais-InstantSearch
    .ais-CurrentRefinements
    .ais-CurrentRefinements-item
    .ais-CurrentRefinements-category
    button.ais-CurrentRefinements-delete {
    position: absolute;
    right: 5px;
    width: 100%;
    height: 100%;
    top: 0;
    margin: 0px;
    text-align: right;
  }
  .ais-InstantSearch
    .ais-CurrentRefinements
    .ais-CurrentRefinements-item
    .ais-CurrentRefinements-category {
    position: relative;
    padding-right: 25px;
  }
}
</style>
